import {load_one, update} from '@/store/action-helpers'

export default {

    loadOne: load_one('order-confirmations/:id'),
    loadOneByPriceId: load_one('prices/:priceId/order-confirmation'),
    update: update('order-confirmations/:id'),

}
